export default [
    {
        name: 'cadastro-logradouro',
        path: 'logradouro',
        redirect: 'logradouro/index',
        component: () => import(/* webpackChunkName: 'cadastro-logradouro' */ '@/views/cadastro/logradouro/Index'),
        children: [
            {
                meta: { title: 'Lista de logradouros' },
                name: 'cadastro-logradouro-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-logradouro' */ '@/views/cadastro/logradouro/List.vue'),
            },
            {
                meta: { title: 'Cadastro de logradouro' },
                name: 'cadastro-logradouro-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-logradouro' */ '@/views/cadastro/logradouro/Form.vue'),
            },
            {
                meta: { title: 'Edição de logradouro' },
                name: 'cadastro-logradouro-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* webpackChunkName: 'cadastro-logradouro' */ '@/views/cadastro/logradouro/Form.vue'),
            },
        ],
    },
]